import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { WsScreenshotTimeline } from './ScreenshotTimeline';




const WsScreenshot = () => {

  useEffect(() => {

    document.documentElement.classList.add('ws-screenshot');

    return () => {
      document.documentElement.classList.remove('ws-screenshot');
    };
  }, []);

  return (
    <>
      <BrowserRouter>
        <Switch>

          <Route path={`/sales/solution/screenshot/:solutionId/:page`} component={WsScreenshotTimeline} />

          {/* <Route path="/loading" component={Loading} />

          <Redirect from="*" to="/" /> */}

        </Switch>
      </BrowserRouter>
    </>
  );
};




export {
  WsScreenshot
};
